module.exports = __webpack_public_path__ + "img/jin11.bbdbcec8.png";